import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { getEntityTemplates } from '../services/dtServices'

export const useEntityTemplates = (
    orgId: string | undefined,
): UseQueryResult<Awaited<ReturnType<typeof getEntityTemplates>>, Error> => {
    return useQuery({
        queryKey: ['entity-templates', orgId],
        queryFn: () => getEntityTemplates(orgId ?? ''),
        enabled: !!orgId,
    })
}
